// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"adb0d653","239":"e7f511e2","455":"c43a3290"}[chunkId] + ".chunk.js";
};